export default __webpack_public_path__ + "static/news22-d8c7d1e3ebed4b9ba7de77ccb07793cf.jpg";